/**
 * User form layout script class
 *
 * @package    Layouts
 * @author     Roman Kritskiy <rkritskiy@mindk.com>
 * @copyright  Copyright (c) 2010-2018 MindK (http://mindk.com). All rights reserved.
 * @license    http://mindk.com
 * @link       http://mindk.com
 */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl';

import {
    ContactInfoForm,
    ProfessionalInfoForm,
    CorporateInfoForm,
    IdsInfoForm,
    PasswordForm, StatusForm,
} from 'Components/FormGroup';

import Button from 'Common/CustomButtons/Button';

import styles from './styles.js';
import { scrollerHandler } from 'Utils';

@withStyles(styles)
@reduxForm({
    form: 'store_user',
    enableReinitialize: true,
    onSubmitFail: scrollerHandler,
})
export default class UserForm extends PureComponent {
    /**
     * @type {Object}
     */
    static propTypes = {
        handleSubmit: PropTypes.func.isRequired,
        submitting: PropTypes.bool,
        pristine: PropTypes.bool,
        initialValues: PropTypes.object,
        classes: PropTypes.object.isRequired,
    };

    /**
     * @type {Object}
     */
    static contextTypes = {
        intl: PropTypes.object.isRequired,
    };

    isDisabled = () => {
        const { pristine, submitting } = this.props;

        return pristine || submitting;
    };

    render() {
        const { handleSubmit, classes } = this.props;

        return (
            <form onSubmit={handleSubmit} id="store_user" className={classes.form}>
                <ContactInfoForm required />

                <ProfessionalInfoForm />

                <CorporateInfoForm />

                <IdsInfoForm exclude={['orcid_link']}/>

                <StatusForm exclude={['is_active']} />

                <PasswordForm required/>

                <div className={classes.center}>
                    <Button round color="primary" disabled={this.isDisabled()} type="submit">
                        <FormattedMessage id="button.save" />
                    </Button>
                </div>
            </form>
        );
    }
}



// WEBPACK FOOTER //
// ./src/layouts/UserCreate/UserForm.jsx